import React from 'react';
import { Link } from 'react-router-dom';

/*
 * Hero photograph. If the file is missing the frame renders a labeled
 * placeholder rather than a broken image, so the layout stays truthful about
 * what isn't there yet.
 *
 * Current source is only 461×332. The frame is ~550 CSS px wide on desktop, so
 * on a retina display this upscales roughly 2.4× and looks soft. Replacing it
 * with a 1600px-wide version is a drop-in — same filename, no code change.
 */
const HERO_IMAGE = process.env.PUBLIC_URL + '/hero-chillers.jpg';

function Hero() {
  const [imageOk, setImageOk] = React.useState(true);

  return (
    <section className="hero">
      <div className="wrap hero-inner">
        <div className="hero-copy">
          <p className="eyebrow eyebrow--accent hero-eyebrow">
            Property-line noise, held to a written SLA
          </p>

          <h1 className="h1 hero-title">Engineering Silence</h1>

          {/* The subhead is the whole repositioning in one sentence, so the
              order of its clauses matters: what we take on, then how it is
              held, then who pays when it slips. Leading with the hardware
              ("we stop the tones barriers can't") made this a product page,
              which is exactly the purchase every failed noise fix in the
              newsreel below already made. */}
          <p className="hero-sub">
            Datacenter projects are being blocked over noise. We take
            responsibility for the level at your property line, held to a
            written SLA, measured continuously, and remedied at our cost.
          </p>

          {/* The technology gets one subordinate line, AFTER the SLA sentence
              and visibly smaller than it. It exists to answer the question the
              subhead raises — how can anyone sign that? — not to reopen the
              hardware pitch. Two facts only, both behaviour: it reaches the
              low band, and it follows the tone. Mechanism, band widths and
              any figure stay off the hero (and off the site — see CLAUDE.md,
              "Tonal tracking"). */}
          <p className="hero-tech">
            Made possible by our own technology: a proprietary low-frequency
            silencer that finds the fan tone and follows it as it moves.
          </p>

          <div className="hero-actions">
            <Link to="/#assessment" className="btn btn--primary">
              Request a site assessment
            </Link>
            <Link to="/#guarantee" className="link-arrow">
              See what we guarantee <span aria-hidden="true">→</span>
            </Link>
          </div>
        </div>

        <div className="hero-figure">
          {imageOk ? (
            <img
              className="hero-image"
              src={HERO_IMAGE}
              alt="Rows of chiller units on a datacenter roof, seen from above"
              width={461}
              height={332}
              /* Above the fold and almost certainly the LCP element — never
                 lazy-load it, and ask for it early. */
              fetchPriority="high"
              decoding="async"
              onError={() => setImageOk(false)}
            />
          ) : (
            <div className="hero-image-placeholder">
              <span className="hero-placeholder-label">
                [ add public/hero-chiller.jpg ]
              </span>
            </div>
          )}
        </div>
      </div>
    </section>
  );
}

export default Hero;
